import { useEffect, useState } from "react";
import axios from "axios";
import AdminLogin from "@/components/admin/AdminLogin";
import LeadsDashboard from "@/components/admin/LeadsDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "hh_admin_token";

export default function Admin() {
  const [token, setToken] = useState(() => sessionStorage.getItem(TOKEN_KEY));
  const [checked, setChecked] = useState(!sessionStorage.getItem(TOKEN_KEY));

  useEffect(() => {
    if (!token || checked) return;
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .catch(() => {
        sessionStorage.removeItem(TOKEN_KEY);
        setToken(null);
      })
      .finally(() => setChecked(true));
  }, [token, checked]);

  const onLogin = (t) => {
    sessionStorage.setItem(TOKEN_KEY, t);
    setToken(t);
    setChecked(true);
  };
  const onLogout = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    setToken(null);
  };

  if (!checked) return <div className="min-h-screen bg-[#FFFFFF]" />;
  return (
    <div className="min-h-screen bg-[#FFFFFF] text-[#0F0F1A]">
      {token ? <LeadsDashboard token={token} onLogout={onLogout} /> : <AdminLogin onLogin={onLogin} />}
    </div>
  );
}
